import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { AddDepartmentData } from '../models/add-department-data';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-department-view',
    templateUrl: './add-department-view.component.html',
    standalone: false
})
export class AddDepartmentViewComponent {
   @Input() callState: CallState;

   @Output() formSubmitted = new EventEmitter<AddDepartmentData>();

   @Output() formCanceled = new EventEmitter<void>();

   @Input() form: UntypedFormGroup;

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      }
   }
}
